import ConnectMvxWallet from './ConnectMvxWallet'
import ConnectEthWallet from './ConnectEthWallet'

const ConnectWallet = ({ network, chain }: { network: string; chain: string }) => {
  return (
    <div className="grid gap-4">
      <h2 className="text-white">Wallet</h2>

      {chain === 'multiversx' && <ConnectMvxWallet />}
      {(chain === 'bnb' || chain === 'polygon' || chain === 'ethereum') && (
        <ConnectEthWallet network={network} chain={chain} />
      )}
    </div>
  )
}

export default ConnectWallet
